import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {TranslationService} from '../../services/translation.service';
import {ToolsService} from '../../services/tools/tools.service';
import {QUILL_ADMIN_CONFIG} from '../../../core/consts/quill';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass, UpperCasePipe } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-ajustement-dossier',
    templateUrl: './modal-ajustement-dossier.component.html',
    styleUrls: ['./modal-ajustement-dossier.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, NgClass, QuillModule, FormsModule, MatIcon, MatDialogActions, MatButton, MatDialogClose, UpperCasePipe, TranslateModule]
})
export class ModalAjustementDossierComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalAjustementDossierComponent>>(MatDialogRef);
    translationService = inject(TranslationService);
    private toolService = inject(ToolsService);


    public text = '';

    public modules = this.toolService.deepCloneQuill(QUILL_ADMIN_CONFIG);

    constructor() {
        if(this.data.dossier.commentaireDS != null) {
            this.text = this.data.dossier.commentaireDS + '<p class="border-top"></p><p></p>';
        }

        if(this.data.dossier.ajustementsNumber == 0) {
            this.text += (this.data.dossier.getLastDecision()?.commentaire?.replace(/(?:\r\n|\r|\n)/g, '<br>')) ?? '';
        }
        this.modules['counter'].container = '#ajustement-comment-counter';
    }

    ngOnInit(): void {
    }

    public getTitreTranslation() {
        return this.translationService.getPropertyTranslation(this.data.dossier, 'titre');
    }

}
